import { render } from "./AdminUsersEditComponent.vue?vue&type=template&id=4c9d72f7"
import script from "./AdminUsersEditComponent.vue?vue&type=script&lang=js"
export * from "./AdminUsersEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__